/*
 * ******************************************************
 * Copyright (C) 1994-2021 Babiel GmbH <info@babiel.com>
 *
 * This file is part of a Babiel development
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted without the express
 * permission of Babiel GmbH
 *
 * Any modification is not permitted without the express
 * permission of Babiel GmbH
 *
 * The file may contain confidential and or privileged materials.
 * Any review, retransmission, dissemination or other use of
 * or taking of any action in reliance upon, this file
 * by persons or entities other than the intended is prohibited.
 * ******************************************************
 */

import { ComponentConfig } from '../../componentSystem/componentConfig';
import { SwiperOptions } from 'swiper';
import { BreakpointService } from '../../services/breakpointService';

export class ContactPersonComponentConfig extends ComponentConfig {
  public static readonly swiperOptions: SwiperOptions = {
    breakpoints: {
      [BreakpointService.breakpoints.md]: {
        slidesPerView: 3,
      },
      [BreakpointService.breakpoints.lg]: {
        slidesPerView: 4,
      },
    },
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '[data-js-swiper-button-next]',
      prevEl: '[data-js-swiper-button-prev]',
      disabledClass: '-hidden',
    },
    pagination: {
      bulletActiveClass: '-active',
      bulletClass: 'o-contactPersons__bullet',
      clickable: true,
      clickableClass: '-clickable',
      el: '[data-js-swiper-pagination]',
      modifierClass: '-',
      type: 'bullets',
    },
    slideActiveClass: '-active',
    slideClass: 'js-swiperSlide',
    slideVisibleClass: '-visible',
    spaceBetween: 32,
    speed: 300,
    watchOverflow: true,
    watchSlidesProgress: true,
    wrapperClass: 'js-swiperWrapper',
  };

  public static readonly swiperContainerSelector: string = '[data-js-swiper-container]';
  public static readonly noAnimateClass: string = '-noAnimate';
  public static readonly wasActiveClass: string = '-wasActive';
}
